import { _ as r } from "./atoms-v21293.js";
import { _ as n } from "./atoms-v21294.js";
var h = r, t = n;
function o(a, s) {
  return a != null && t(a, s, h);
}
var I = o;
export {
  I as h
};
